/*
LINE WOKRSモーダル内のエラー関係で取り扱うクラスや関数。
*/

const ERROR_MESSAGE = Object.freeze({
  NOT_FOUND: '存在していない値です',
  HTTP: 'APIとの通信でエラーが発生しました',
  NOT_IMPLEMENTED_ERROR: '実装されていません',
});

// Babelを利用してES6に対応しているため、普通にErrorクラスを継承しても独自エラーを作成できない。
// 以下のエラー実装は、以下のページを参照した。
// https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript

// 存在しないデータを取得しようとした時に発生させるエラー
function NotFoundError(...args) {
  if (args.length === 0) {
    args.push(ERROR_MESSAGE.NOT_FOUND);
  }
  const instance = Reflect.construct(Error, args);
  Reflect.setPrototypeOf(instance, Reflect.getPrototypeOf(this));
  return instance;
}
NotFoundError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true,
  },
});
Reflect.setPrototypeOf(NotFoundError, Error);

// HTTP通信でエラーが発生した時に発生させるエラー
function HttpError(...args) {
  if (args.length === 0) {
    args.push(ERROR_MESSAGE.HTTP);
  }
  const instance = Reflect.construct(Error, args);
  Reflect.setPrototypeOf(instance, Reflect.getPrototypeOf(this));
  return instance;
}
HttpError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true,
  },
});
Reflect.setPrototypeOf(HttpError, Error);

//未実装のエラー
function NotImplementedError(...args) {
  if (args.length === 0) {
    args.push(ERROR_MESSAGE.NOT_IMPLEMENTED_ERROR);
  }
  const instance = Reflect.construct(Error, args);
  Reflect.setPrototypeOf(instance, Reflect.getPrototypeOf(this));
  return instance;
}
NotImplementedError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true,
  },
});
Reflect.setPrototypeOf(NotImplementedError, Error);

export { ERROR_MESSAGE, NotFoundError, HttpError, NotImplementedError };



// WEBPACK FOOTER //
// ./src/services/lwUser/Error.js